<template>
  <vs-tabs :value="1">
    <vs-tab label="학교 등록" @click="onClickTab(0)"> </vs-tab>
    <vs-tab label="학교 현황" @click="onClickTab(1)">
      <!-- 간편 찾기 -->
      <vx-card class="mb-8">
        <vs-row class="flex w-auto mr-4" vs-align="center">
          <vs-col class="w-auto mr-4">간편 찾기</vs-col>
          <vs-col class="w-auto">
            <vs-select autocomplete v-model="selectedCompany">
              <vs-select-item v-for="(item, index) in companyList" :key="index" :text="item.com_name" :value="item" />
            </vs-select>
          </vs-col>
        </vs-row>
      </vx-card>

      <!-- 내용 -->
      <vx-card>
        <!-- 학교 현황 -->
        <div>
          <p class="title mb-5">학교 현황</p>
          <div class="select-table-container">
            <table class="select-table">
              <colgroup>
                <col width="84" />
              </colgroup>
              <thead>
                <th>No.</th>
                <th>학교 구분</th>
                <th>학교명</th>
                <th>학교장</th>
                <th>행정실장</th>
                <th>학교 담당자</th>
              </thead>
              <tbody>
                <tr v-for="tr in table.list" :key="tr.id" :class="selectId === tr.id && 'selected'" @click="onClickSelectData(tr)">
                  <td>{{ tr.id }}</td>
                  <td>{{ !!tr.facility_category_id ? tr.facility_category.cat3 : "-" }}</td>
                  <td>{{ !!tr.field_name ? tr.field_name : "-" }}</td>
                  <td>{{ !!tr.director_name ? tr.director_name : "-" }}</td>
                  <td>{{ !!tr.meta.행정실장 ? tr.meta.행정실장 : "-" }}</td>
                  <td>{{ !!tr.meta.학교담당자 ? tr.meta.학교담당자 : "-" }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="vs-con-table">
            <div class="con-pagination-table vs-table--pagination">
              <k-pagination :total="lastPage ? lastPage : 1" v-model="currentPage" @change="handleChangePage"></k-pagination>
            </div>
          </div>
        </div>

        <!-- 학교 정보 -->
        <div>
          <p class="title mt-8 mb-5">학교 정보</p>
          <div class="writeGridContainer">
            <div>
              <div>학교 구분</div>
              <ml-input readonly :value="!!selectData ? selectData.facility_category.cat3 : ''" />
            </div>
            <div>
              <div>학교명</div>
              <ml-input readonly :value="!!selectData ? selectData.field_name : ''" />
            </div>
            <div>
              <div>학교장</div>
              <ml-input readonly :value="!!selectData ? selectData.director_name : ''" />
            </div>
            <div>
              <div>행정실장</div>
              <ml-input readonly :value="!!selectData ? selectData.meta.행정실장 : ''" />
            </div>
            <div>
              <div>학교 담당자</div>
              <ml-input readonly :value="!!selectData ? selectData.meta.학교담당자 : ''" />
            </div>
            <div>
              <div>연락처</div>
              <ml-input readonly :value="!!selectData ? selectData.phone : ''" />
            </div>
            <div>
              <div>학교 주소</div>
              <ml-input readonly :value="!!selectData ? selectData.address : ''" />
            </div>
            <div>
              <div>설립일 ~ 폐교일</div>
              <date-selector-rang readonly :value="!!selectData ? { sDate: selectData.start_work_at, eDate: selectData.be_completed_at } : ''" />
            </div>
          </div>
        </div>

        <!-- 취약개소 현황(unit : ea) -->
        <div class="vulnerable mb-5">
          <h5 class="mb-5"><i class="dot"></i> 취약개소 현황(unit : ea)</h5>
          <table>
            <thead>
              <th v-for="vulnerable in vulnerableList" :key="vulnerable">
                {{ vulnerable }}
              </th>
            </thead>
            <tbody>
              <tr>
                <td v-for="vulnerable in vulnerableList" :key="vulnerable">
                  <comma-input readonly class="w-full" :value="!!selectData && !!selectData.meta.vulnerable[vulnerable] ? selectData.meta.vulnerable[vulnerable] : ''" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div>
          <p class="title mb-5">기관 정보</p>
          <div class="select-table-container">
            <table class="select-table">
              <colgroup>
                <col width="84" />
              </colgroup>
              <thead>
                <th>No.</th>
                <th>구분</th>
                <th>부서/업체명</th>
                <th>대표자</th>
                <th>담당자</th>
                <th>연락처</th>
              </thead>
              <tbody>
                <tr v-for="tr in companyTable.list" :key="tr.id">
                  <td>{{ tr.id }}</td>
                  <td>{{ tr.com_type }}</td>
                  <td>{{ tr.com_name }}</td>
                  <td>{{ tr.com_ceo }}</td>
                  <td>{{ tr.director }}</td>
                  <td>{{ tr.com_number }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="vs-con-table">
            <div class="con-pagination-table vs-table--pagination">
              <k-pagination :total="companyTable.lastPage ? companyTable.lastPage : 1" v-model="companyTable.currentPage" @change="handleCompanyChangePage"></k-pagination>
            </div>
          </div>
        </div>

        <!-- 참여 인원 정보 -->
        <company-user-auth-module
          :colData="[
            { head: '구분', key: 'department' },
            { head: '사용자명', key: 'name' },
            { head: '연락처', key: 'phone' },
          ]"
          :users="users"
          type="info"
        />
      </vx-card>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import FileInput from "@/components/custom/FileInput";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import SearchNavStartEnd from "@/components/nav/SearchNavStartEnd.vue";
import FileUploadModule from "@/views/modules/FileUploadModule";
import CompanyUserAuthModule from "@/views/_BS/components/CompanyUserAuthModule";
import DateSelector from "@/components/selector/DateSelector";
import KPagination from "@/components/kPagination/kPagination";
import CompanyAddModule from "@/views/_BS/components/SimpleCompanyAddModule";
import DateSelectorRang from "@/components/selector/DateSelectorRang";

export default {
  components: {
    DateSelector,
    CompanyUserAuthModule,
    SearchNavStartEnd,
    SearchNavItemSelect,
    FileInput,
    FileUploadModule,
    KPagination,
    CompanyAddModule,
    DateSelectorRang,
  },
  data() {
    return {
      // 부서명
      selectedCompany: null,
      companyList: [],

      // 창고 현황
      currentPage: 1,
      lastPage: 1,
      total: 0,
      table: {
        list: [],
        perPage: 5,
        keyword: "",
      },
      selectId: null,
      selectData: null,

      // 분기별 근로자 근무(예정)현황(명)
      seasonYear: new Date().getFullYear(),
      quarterData: [],

      // 부서정보
      companyTable: {
        list: [],
        page: 1,
        lastPage: 1,
        total: 0,
        perPage: 5,
      },

      keyword: "",
      users: [],
    };
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    vulnerableList() {
      return ["사무실", "교실", "양호실", "과학실", "급식실", "음악실", "도서실", "휴게실", "경비실", "체육관", "창고", "화장실", "승강기", "에스컬레이터", "옹벽", "비탈사면", "공사현장", "기타"];
    },
  },
  watch: {
    selectedCompany(/*value*/) {
      // 초기화
      this.currentPage = 1;
      this.lastPage = 1;
      this.total = 0;
      this.table = {
        list: [],
        perPage: 5,
        keyword: "",
      };
      this.selectId = null;
      this.selectData = null;

      this.keyword = "";
      this.users = [];

      this.loadCompanyInfo();
    },
  },
  created() {
    this.initBreadcrumb();
  },
  mounted() {
    this.$store.dispatch("company/LOAD_COMPANY_TREE", { projectId: this.projectId }).then(async (value) => {
      const companyTree = value;
      const list = [];
      for (const com of companyTree) {
        list.push(com.descendant);
      }
      this.companyList = list;

      let myInfo = this.$store.state.auth.userInfo;
      if (!myInfo.company_id) {
        await this.$store.dispatch("USER_INFO");
        myInfo = this.$store.state.auth.userInfo;
      }
      this.selectedCompany = this.companyList.find((com) => com.id === myInfo.company_id);

      this.loadCompanyInfo();
      this.loadQuarterData();
    });
  },
  methods: {
    initBreadcrumb() {
      this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "학교 현황" }, { title: "학교", active: true }]);
    },
    onClickTab(tabIndex) {
      if (tabIndex === 0) {
        this.$router.push({ name: "field-school-list" });
      } else if (tabIndex === 1) {
        this.$router.push({ name: "field-school-info" });
      }
    },

    // =============== 창고 현황 ===============
    loadCompanyInfo() {
      if (!this.selectedCompany) return;
      const page = this.currentPage;
      const perPage = this.table.perPage;
      const companyId = this.selectedCompany.id;
      const projectId = this.projectId;
      this.$store.dispatch("company/LOAD_COMPANY_FIELD", { companyId, projectId, fieldCode: "school", page, perPage }).then((value) => {
        const fieldListInfo = value;
        this.table.list = fieldListInfo.data.map((item) => {
          return { ...item, meta: JSON.parse(item.meta) };
        });

        this.currentPage = fieldListInfo.current_page;
        this.lastPage = fieldListInfo.last_page;
        this.total = fieldListInfo.total;

        this.keyword = "";
        this.users = [];
      });
    },

    onClickSelectData(data) {
      this.selectId = data.id;
      this.selectData = data;

      this.loadFieldCompanys();
      this.loadFieldUsers();
    },
    handleChangePage(page) {
      this.currentPage = page;
      this.loadCompanyInfo();
    },

    // =============== 분기별 근로자 근무(예정)현황(명) ===============
    async loadQuarterData() {
      const params = {
        projectId: this.projectId,
        targetYear: this.seasonYear,
      };
      const data = await this.$store.dispatch("summary/LOAD_SUMMARY_EMPLOYEE_QUARTER", params);
      this.quarterData = data.quarter;
    },

    // =============== 부서 정보 ===============
    loadFieldCompanys() {
      if (this.selectId) {
        this.$store.dispatch("project/LOAD_FIELD_COMPANYS", { fieldId: this.selectId, page: this.companyTable.page, perPage: this.companyTable.perPage }).then((result) => {
          this.companyTable.lastPage = result.last_page;
          this.companyTable.total = result.total_count;
          this.companyTable.list = result.data;
        });
      }
    },
    handleCompanyChangePage(page) {
      this.companyTable.currentPage = page;
      this.loadFieldCompanys();
    },
    selectCompany(data) {
      this.loadFieldUsers();
    },

    // =============== 참여 인원 정보 ===============
    loadFieldUsers() {
      if (this.selectId) {
        this.$store.dispatch("project/LOAD_FIELD_USERS", { fieldId: this.selectId }).then((value) => {
          this.users = value.data;
        });
      }
    },

    // =============== 기타 ===============
    jsonParse(str) {
      return JSON.parse(str);
    },
    totalNumDevices(data) {
      // 오브젝트의 value를 전부 합한 값을 리턴
      let sum = 0;
      for (const key in data) {
        sum += data[key];
      }
      return sum;
    },
  },
};
</script>

<style scoped lang="scss">
.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 12px;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -8px;
    border-radius: 100%;
  }
}

.vs-table-primary .is-selected {
  background: rgba(126, 114, 242, 0.6) !important;
  color: white;
}

.search-item {
  width: 100% !important;
  margin: 0 !important;

  &::v-deep > div:first-child {
    width: 114px !important;
    font-weight: 500;
    font-size: 14px;
  }

  &::v-deep > div:last-child {
    flex: 1 !important;

    .con-select {
      width: 100%;
    }
  }
}

.select-table-container {
  overflow-x: auto;
  table.select-table {
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;
    min-width: 1200px;

    background: #f8f8f8;
    border: 2px solid #f8f8f8;

    th,
    td {
      text-align: center;
      background: white;
      padding: 10px 15px;
    }

    td {
      cursor: pointer;
    }

    tr:nth-child(1) td {
      background: #f8f8f8;
    }

    tr.selected td {
      background: rgba(126, 114, 242, 0.6) !important;
      color: white;
    }
  }
}

table.custom {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;

  th,
  td {
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 500;
    font-size: 14px;
    text-align: center;

    background: #f9f9f9;
    padding: 15px 4px;
  }
  td {
    height: 40px;

    text-align: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;

    padding: 6px;
  }
}

.vulnerable table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;

  th,
  td {
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 500;
    font-size: 14px;
    text-align: center;

    background: #f9f9f9;
    padding: 15px 4px;
  }
  td {
    padding: 6px;
  }
}
</style>
